<script setup lang="ts">
import { onMounted } from 'vue';
import { useEsignatureFlowStore } from '@Stores/esignatureFlow.store';
import useFlowNavigation from '@Use/useFlowNavigation';
import { verifyUserApi } from '@Api/activitySession.api';

const esignatureFlowStore = useEsignatureFlowStore();
const { resumeFlow } = useFlowNavigation();

onMounted(async () => {
    await bootstrapMfe();
});


// First, invisible page, of mfe flow where auth will be required
const bootstrapMfe = async () => {
    await verifyUserApi();

    await esignatureFlowStore.loadEsignatureFlow();
    resumeFlow();
};

</script>


<template>
    <app-page-loader />
</template>